
<template>
  <div>
    <ClaimList :isReport="true"></ClaimList>
  </div>
</template>
<script type="text/javascript">
import ClaimList from '@/Osm/Claim/containers/ClaimList'
  export default{
    name: 'ReportClaim',
    components:{
      ClaimList
    }
  }
</script>


// WEBPACK FOOTER //
// src/Dw/containers/ReportClaim.vue